import React from "react";
import { Button } from "../../../../design/button";
import { TrashIcon } from "@heroicons/react/16/solid";
import { useCase } from "../../../../contexts/CaseContext";
import { useContract } from "../../../../contexts/ContractContext";
import { useDeleteAlert } from "../../../../contexts/DeleteAlertProvider";
import { Contract } from "@visitproof/types";

interface Props {
  contract: Contract;
}

const DeleteContractButton: React.FC<Props> = ({ contract }) => {
  const { setSelectedCase } = useCase();
  const { deleteContractById } = useContract();
  const { openAlert } = useDeleteAlert();

  const handleDelete = async (id: string) => {
    await deleteContractById(id);
    setSelectedCase(contract.caseId);
  };

  const handleClick = () => {
    openAlert(
      contract,
      {
        displayName: "contract",
        onDelete: handleDelete,
        getId: (entity) => entity.id,
      }
    );
  };

  return (
    <Button type="button" color="red" onClick={handleClick}>
      <TrashIcon className="w-5 h-5" aria-hidden="true" />
    </Button>
  );
};

export default DeleteContractButton;
